import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { DeleteConfirmPopInComponent } from '@pkg-components/confirm/delete-confirm-pop-in/delete-confirm-pop-in.component';
import { DeleteConfirmPopInService } from '@pkg-services/confirm/delete-confirm-pop-in.service';

@Component({
  selector: 'pkg-delete-confirm-pop-in-host',
  standalone: true,
  imports: [CommonModule, DeleteConfirmPopInComponent],
  template: `
    <pkg-delete-confirm-pop-in
      [isVisible]="(svc.state$ | async)?.isVisible || false"
      [title]="(svc.state$ | async)?.title || ''"
      [message]="(svc.state$ | async)?.message || ''"
      [confirmLabel]="(svc.state$ | async)?.confirmLabel || 'Supprimer'"
      [cancelLabel]="(svc.state$ | async)?.cancelLabel || 'Annuler'"
      [confirmButtonColor]="(svc.state$ | async)?.confirmButtonColor || 'var(--theme-danger-color)'"
      [confirmLabelColor]="(svc.state$ | async)?.confirmLabelColor || '#fff'"
      (cancel)="svc.cancel()"
      (confirm)="svc.accept()">
    </pkg-delete-confirm-pop-in>
  `,
})
export class DeleteConfirmPopInHostComponent {
  constructor(public svc: DeleteConfirmPopInService) {}
}

